module.exports = __webpack_public_path__ + "static/media/mobileweb.8ccbb39c.svg";